import { useGetActiveUser, useUserRename } from "@/api";
import { Settings } from "@/components/ui/SettingsSection";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { LoadingCircle } from "@/components/ui/loadingCircle";
import { toast } from "@/components/ui/use-toast";
import { motion } from "framer-motion";
import { CircleX, Save } from "lucide-react";
import { useEffect, useState } from "react";

export function UserNameRow() {
  const { data, loading } = useGetActiveUser();
  const [renameUser, { loading: renamingUser }] = useUserRename();
  const [newName, setNewName] = useState("");

  useEffect(() => {
    if (data?.me.fullName) setNewName(data.me.fullName);
  }, [data?.me.fullName]);

  function handleRenameSubmit() {
    renameUser({ variables: { fullName: newName } })
      .then((res) => {
        if (res.data?.userRename?.__typename === "User")
          toast({
            title: "Name updated"
          });
        else {
          console.error("UserRename error: ", res.errors);
          toast({
            title: "Unable to update name",
            description:
              "An error occurred while updating your name. Please try again."
          });
        }
      })
      .catch((e) => {
        console.error(e);
        toast({
          title: "Unable to update name",
          description:
            "An error occurred while updating your name. Please try again."
        });
      });
  }

  const hasNameChanged = !loading && newName.trim() !== data?.me.fullName;

  if (!loading && !data) return null;

  return (
    <Settings.Item title="Name">
      {loading ? (
        <LoadingCircle />
      ) : (
        <div className="grid grid-cols-[1fr_72px] gap-2 md:gap-4 items-center">
          <Input
            data-testid="renameInput"
            type="text"
            id="name"
            defaultValue={newName}
            onChange={(e) => setNewName(e.currentTarget.value)}
            disabled={renamingUser}
            className="min-w-36 text-sm bg-white dark:bg-brand-gray-800 text-brand-gray-900 dark:text-brand-gray-100 border border-brand-gray-200 dark:border-brand-gray-700"
          />
          {hasNameChanged && (
            <motion.div
              key="saveClearBtns"
              className="flex flex-row"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
            >
              <Button
                variant="ghost"
                size="icon"
                data-testid="saveNameBtn"
                onClick={handleRenameSubmit}
                disabled={!newName}
              >
                <Save size={16} />
              </Button>

              <Button
                variant="ghost"
                size="icon"
                data-testid="clearNameBtn"
                onClick={() =>
                  data?.me.fullName && setNewName(data?.me.fullName)
                }
              >
                <CircleX size={16} />
              </Button>
            </motion.div>
          )}
        </div>
      )}
    </Settings.Item>
  );
}
